WB.DataManagers = WB.DataManagers || {};
WB.DataManagers.Snowski = function ($q, SnowskiDataService, DataManagerUtility) {
     
    this.GetSnowskiData = function(lat, lng) {
        return SnowskiDataService.GetSnowskiDataByLatLng(lat, lng);
    };

};
WB.DataManagers.Snowski.$inject = ['$q', 'SnowskiDataService', 'DataManagerUtility'];

WB.Core.service('SnowskiDataManager', WB.DataManagers.Snowski);